<div fxLayout="column" class="card-profile-container">
  <mat-card class="mat-card users-card">
    <div
      class="title-container"
      fxFlex
      fxLayout="row"
      fxLayoutAlign="start center">
      <h2 class="card-title">
        {{ title() | translate }}
      </h2>
      @if (showFilters) {
        <div class="button-section">
          <button
            mat-icon-button
            (click)="reloadUsers()"
            aria-label="refresh"
            class="reload-button search-button-action">
            <mat-icon>refresh</mat-icon>
          </button>
        </div>
        <div class="button-section">
          <button
            mat-icon-button
            (click)="filterUsers(true)"
            aria-label="refresh"
            class="filter-button"
            [ngClass]="{ active: isFilterActive }">
            <mat-icon>filter_alt</mat-icon>
          </button>
        </div>
      }
    </div>

    @if (!hideAllCard) {
      <div class="search-section">
        <div class="search-field">
          <div class="search-wrapper">
            <div
              class="search"
              fxFlex
              fxLayout="row"
              fxLayoutAlign="start center">
              <mat-icon>search</mat-icon>
              <input
                autoComplete="on"
                #filter
                [formControl]="firstNameSearchField"
                matInput
                placeholder="{{ 'TABLE.SEARCH.FIRSTNAME' | translate }}" />
            </div>
          </div>
          <div class="search-wrapper">
            <div
              class="search"
              fxFlex
              fxLayout="row"
              fxLayoutAlign="start center">
              <mat-icon>search</mat-icon>
              <input
                autoComplete="on"
                #filter
                [formControl]="lastNameSearchField"
                matInput
                placeholder="{{ 'TABLE.SEARCH.NAME' | translate }}" />
            </div>
          </div>
          <div class="search-wrapper">
            <div
              class="search"
              fxFlex
              fxLayout="row"
              fxLayoutAlign="start center">
              <mat-icon>search</mat-icon>
              <input
                autoComplete="on"
                #filter
                [formControl]="emailSearchField"
                matInput
                placeholder="{{ 'TABLE.SEARCH.EMAIL' | translate }}" />
            </div>
          </div>
        </div>
      </div>
      @if (isLoading) {
        <div
          class="general-container"
          fxLayout="row"
          fxLayoutAlign="center center">
          <mat-progress-spinner
            [color]="spinner.color"
            [mode]="spinner.mode"
            [value]="spinner.value"
            [diameter]="spinner.diameter">
          </mat-progress-spinner>
        </div>
      } @else if (!isLoading && dataSource.filteredData.length > 0) {
        <table
          id="gridContainer"
          mat-table
          [dataSource]="dataSource"
          multiTemplateDataRows>
          <ng-container matColumnDef="firstName">
            <th mat-header-cell *matHeaderCellDef>
              {{ 'TABLE.ADD-USER.HEADER.FIRSTNAME' | translate }}
            </th>
            <td mat-cell *matCellDef="let user">
              {{ user.firstName }}
            </td>
          </ng-container>
          <ng-container matColumnDef="lastName">
            <th mat-header-cell *matHeaderCellDef>
              {{ 'TABLE.ADD-USER.HEADER.LASTNAME' | translate }}
            </th>
            <td mat-cell *matCellDef="let user">
              {{ user.lastName }}
            </td>
          </ng-container>
          <ng-container matColumnDef="officialemail">
            <th mat-header-cell *matHeaderCellDef>
              {{ 'TABLE.ADD-USER.HEADER.EMAIL' | translate }}
            </th>
            <td mat-cell *matCellDef="let user">
              {{ user.officialemail }}
            </td>
          </ng-container>
          <ng-container matColumnDef="expand">
            <th mat-header-cell *matHeaderCellDef aria-label="row actions">
              &nbsp;
            </th>
            <td mat-cell *matCellDef="let user">
              <button
                mat-icon-button
                aria-label="expand row"
                (click)="
                  expandedUser = expandedUser === user ? null : user;
                  $event.stopPropagation()
                ">
                <mat-icon>more_horiz</mat-icon>
              </button>
            </td>
          </ng-container>

          <ng-container matColumnDef="expandedDetail">
            <td
              mat-cell
              *matCellDef="let user"
              [attr.colspan]="displayedColumns.length">
              <div class="user-detail">
                @if (hiddenColumns.includes('officialemail')) {
                  <div class="user-mail">
                    <div class="title">
                      {{ 'TEAMS-PAGE.MAIL' | translate }} :
                    </div>
                    <div class="content">{{ user.officialemail }}</div>
                  </div>
                }
              </div>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr
            mat-row
            *matRowDef="
              let row;
              let index = dataIndex;
              columns: displayedColumns
            "
            class="user-row"></tr>
          <tr
            mat-row
            *matRowDef="let user; columns: ['expandedDetail']"
            [class.show-hide]="expandedUser !== user"></tr>
        </table>
      } @else {
        <h1 class="no-item">
          {{
            'USERS-TABLE.NO-' + usersType().toUpperCase() + '-FILTERED'
              | translate
          }}
        </h1>
      }
    } @else {
      <h1 class="no-item">
        {{ 'USERS-TABLE.NO-' + usersType().toUpperCase() | translate }}
      </h1>
    }
    <div [hidden]="isLoading || hidePagination">
      <mat-paginator
        class="paginator"
        [length]="contextStorage.length"
        [pageSize]="contextStorage.pageSize"
        [pageIndex]="contextStorage.pageIndex"
        (page)="onPage($event)"
        [hidePageSize]="true">
      </mat-paginator>
    </div>
  </mat-card>
</div>
